import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { IadditionalServiceDataForToolLogistics } from '../../../../types/product.configuration.types';
import { markAdditionalServiceAsExternal, unmarkExternalAdditionalService } from '../../../../services/services';
import {
  displayErrorNotification,
  displaySuccessNotification
} from '../../../../utils/displayNudosStandardNotifications';
import { NudosSelectButton, NudosUploadDownloadButton } from '../../../NudosComponents';
import ExternalWipingModal from './ExternalWipingModal/ExternalWipingModal';
import { CONFIG_CLASS_ID } from 'types/product.configuration.types';
import './ExternalWipingSection.scss';

const ExternalWipingSection = ({
  productId,
  wipingService,
  updateDataCallback
}: {
  productId: number;
  wipingService?: IadditionalServiceDataForToolLogistics;
  updateDataCallback: () => Promise<void>;
}) => {
  const { logisticServiceId } = useParams<{ logisticServiceId: string }>();
  const { id: logisticAdditionalServiceProductId, status } = wipingService || {};
  const { isExternalService, imageUrl } = status || {};

  const [loadingExternalWipingUnmarking, setLoadingExternalWipingUnmarking] = useState<boolean>(false);
  const [showExternalWipingModal, setShowExternalWipingModal] = useState<boolean>(false);

  const errorWipingDocument = !imageUrl;

  const closeModal = () => setShowExternalWipingModal(false);

  const markExternalWiping = async (file?: File, loadingHandler?: React.Dispatch<React.SetStateAction<boolean>>) => {
    if (!logisticServiceId || !productId || !file) return;
    try {
      loadingHandler && loadingHandler(true);
      const body = {
        productId,
        logisticServiceId: +logisticServiceId,
        configClassId: CONFIG_CLASS_ID.WIPING
      };
      await markAdditionalServiceAsExternal(body, file);
      await updateDataCallback();
      displaySuccessNotification({ customJSXMessage: <>Servicio adicional actualizado con éxito</> });
      closeModal();
    } catch {
      displayErrorNotification();
    } finally {
      loadingHandler && loadingHandler(false);
    }
  };

  const updateExternalWipingStatus = async () => {
    if (!isExternalService) return setShowExternalWipingModal(true);
    if (!logisticAdditionalServiceProductId) return;
    try {
      setLoadingExternalWipingUnmarking(true);
      const body = {
        logisticAdditionalServiceProductId,
        configClassId: CONFIG_CLASS_ID.WIPING
      };
      await unmarkExternalAdditionalService(body);
      await updateDataCallback();
      displaySuccessNotification({ customJSXMessage: <>Servicio adicional actualizado con éxito</> });
    } catch {
      displayErrorNotification();
    } finally {
      setLoadingExternalWipingUnmarking(false);
    }
  };

  if (loadingExternalWipingUnmarking) return <div className="externalWipingLoader animationLoader" />;
  return (
    <div className="externalWipingSection">
      {showExternalWipingModal && (
        <ExternalWipingModal closeModal={closeModal} markExternalWiping={markExternalWiping} />
      )}
      <div className="externalWiping">
        <div className="checkboxButtonLine">
          <NudosSelectButton isButtonActive={!!isExternalService} handleClickButton={updateExternalWipingStatus} />
          <div className="wipingText">Llegó con Wiping a bodegas</div>
        </div>

        {isExternalService && (
          <NudosUploadDownloadButton
            customClassName="externalWipingProofUploadButton"
            customWidth="127px"
            uploadedFileHandler={(file?: File) => markExternalWiping(file)}
            currentFileUrl={imageUrl || undefined}
            downloadButtonText="Consultar evidencia"
            buttonEmptyText="PDF o JPG"
            buttonFilledText="PDF o JPG"
            showSkeletonLoader={false}
            keepOwnFileState={false}
            errorUploadDownloadButton={errorWipingDocument}
          />
        )}
      </div>
    </div>
  );
};

export default ExternalWipingSection;
